import React, { FC } from 'react';
import { FindingTypeProperty, FindingTypeRuleDetails } from '../../../AnnotationStandardForm/AnnotationStandardForm.slice';
import { CreateAnnotationProperty } from '../AnnotationForm.types';
import { Form, Select, Tooltip } from 'antd';
import styles from '../AnnotationForm.module.scss';
import { prepareSelectInputValues } from '../Helpers';
import PropertyInputType from './PropertyInputType';
import { valueUpdated } from '../Helpers';

const { Option } = Select;

type Props = {
  propertyTemplate: FindingTypeProperty | undefined;
  group: CreateAnnotationProperty[];
  property: CreateAnnotationProperty;
  index: number;
  selectedRules: FindingTypeRuleDetails[];
  properties: CreateAnnotationProperty[][];
  updateProperties: (properties: CreateAnnotationProperty[][]) => void;
  isWarrantyCaseClosed: boolean;
};

export const PropertyInput: FC<Props> = ({
  propertyTemplate,
  group,
  property,
  index,
  selectedRules,
  properties,
  updateProperties,
  isWarrantyCaseClosed
}) => {
  if (!propertyTemplate) return null;

  if (propertyTemplate.values && propertyTemplate.values !== '') {
    const values = prepareSelectInputValues(propertyTemplate, group, property, index, selectedRules, properties, updateProperties);

    return (
      <Tooltip placement='left' title={property.value}>
        <Form.Item key={property.findingTypePropertyId} className={styles.antFormItem} label={property.label} required={property.required}>
          <Select
            showSearch
            style={{ width: '100%' }}
            onChange={(e: any) => valueUpdated(property.findingTypePropertyId, e.toString(), updateProperties, properties)}
            value={property.value}
            optionFilterProp='children'
            filterOption={true}
            disabled={property.isReadonly || isWarrantyCaseClosed}
          >
            {values.map(value => (
              <Option className={'extendedOption'} key={value} value={value}>
                {value}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Tooltip>
    );
  }

  return property.name.includes('ShapeOnCanvas') || property.name.includes('HomographyShape') ? null : (
    <Form.Item key={property.findingTypePropertyId} className={styles.antFormItem} label={property.label} required={property.required}>
      <PropertyInputType property={property} propertyTemplate={propertyTemplate} properties={properties} updateProperties={updateProperties} />
    </Form.Item>
  );
};

export default PropertyInput;
